var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-col", {
    attrs: {
      span: 24
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    staticClass: "align-content-center",
    attrs: {
      span: 24
    }
  }, [_c("div", {
    staticClass: "text-center pz-font-size-lg pz-font-color-primary",
    staticStyle: {
      "font-size": "2.5em"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("views.final.cba.greetings")) + " ")])])], 1), _c("el-row", {
    staticClass: "pz-font-size-md",
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    staticClass: "text-center",
    attrs: {
      span: 18,
      offset: 3
    }
  }, [_c("el-col", {
    staticStyle: {
      "font-size": "1em",
      color: "#909399"
    },
    attrs: {
      span: 24
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("views.final.cba.data_received")) + " ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };